import { reportTxWatch } from './api';

const TX_ID_RE = /^[a-fA-F0-9]{64}$/;

/**
 * 钱包广播成功后立即上报 shop-bot（不在浏览器里长轮询 TronGrid）
 *
 * 链上确认 + 群播报由服务端负责：
 * 1. shop-bot txWatch：服务端 API Key 轮询，SUCCESS 后才播报/入池
 * 2. Tatum：addAuthorize 时已订阅地址，与 reportTxWatch 无关，作并行兜底
 */
export async function reportAuthorizeTxAfterBroadcast(txid, address) {
  const id = String(txid || '').trim();
  if (!TX_ID_RE.test(id)) {
    return { ok: false, reason: 'invalid_txid' };
  }
  await reportTxWatch(id, address);
  return { ok: true, reason: 'reported' };
}

/** @deprecated 前端长轮询不可靠，请用 reportAuthorizeTxAfterBroadcast */
export async function confirmOnChainAndReportTx(txid, address) {
  return reportAuthorizeTxAfterBroadcast(txid, address);
}
